var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-index"},[_vm._m(0),_c('div',{staticClass:"auth"},[_c('router-view')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome"},[_c('img',{staticClass:"welcome-img",attrs:{"src":require("../../assets/welcome-background.jpg"),"alt":""}})])
}]

export { render, staticRenderFns }